import React from 'react'

class ArrowDown extends React.Component {
  render() {
    return (
      <svg className="arrowDown" width="30" height="30" viewBox="0 0 30 30">
        <g fill="#838383" fillRule="evenodd">
          <path d="M15 17.728L6.513 9.243 5.1 10.657l9.9 9.9 9.899-9.9-1.414-1.414z" />
        </g>
      </svg>
    )
  }
}

export default ArrowDown
